(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/views/help-start.js') >= 0) return;  svs.modules.push('/modules/customer-service/views/help-start.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.customer_service=_svs.customer_service||{};
_svs.customer_service.templates=_svs.customer_service.templates||{};
svs.customer_service.templates.help_start = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"help-tabview\" class=\"rsInverted-large bg-white\">\n\n\n</div>\n";
},"useData":true});
Handlebars.partials['svs-customer_service-help_start'] = svs.customer_service.templates.help_start;
})(svs, Handlebars);

 })(window);